var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"320","type":"pie","dir":"ltr","series":_vm.series,"options":_vm.pieChart.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }